import { createTheme } from "../Utils/applyTheme"

const darkTheme = createTheme({
    primary: "#6366f1",
    text: "white",
    bg: "#111827",
    bgSecondary: "#1f2937"
})

export default darkTheme